import React, { useEffect, useState } from "react";
import "../sections.css";
import { getTarjetasInicio } from "../../../../config/services/strapi/home";
import TextSkeleton from "../../../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../../../components/Skeleton/ImageSkeleton";

export default function Proyecto() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const tarjetas = await getTarjetasInicio();
        const tarjetaProyecto = tarjetas.find(
          (t: any) => t.titulo === "PROYECTO"
        );
        setData(tarjetaProyecto);
      } catch (error) {
        console.error("Error cargando Proyecto desde Strapi:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  const imageUrl = data?.portada?.url || null;

  return (
    <section className="section proyecto">
      <div className="section-inner">
        <div className="col-media">
          {loading ? (
            <ImageSkeleton className="h-full relative z-[99999] pointer-events-none" />
          ) : (
            <div
              className="media-cover"
              style={{
                backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
                backgroundColor: "#f0f0f0"
              }}
            />
          )}
          <a href="/proyecto" className="full-link" aria-label="Ir a Proyecto" />
        </div>

        <div className="col-text">
          {loading ? <TextSkeleton className="relative z-[99999] pointer-events-none" /> : <h1>{data?.Titulo || "PROYECTO"}</h1>}
          <a href="/proyecto" className="full-link" aria-label="Ir a Proyecto" />
        </div>
      </div>
    </section>
  );
}